// extracted by mini-css-extract-plugin
export default {"control":"ProfileContent_control__8DFzk","flexContainer":"ProfileContent_flexContainer__U4S1F"};